import { render, staticRenderFns } from "./OtherCommonPay.vue?vue&type=template&id=5178e44d&"
import script from "./OtherCommonPay.vue?vue&type=script&lang=ts&"
export * from "./OtherCommonPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports